<template>
  <div>
      <ClarenceReports></ClarenceReports>
</div>
</template>

<script>
import ClarenceReports from "../components/ClarenceReportsAll.vue"
export default {
  name: "ReportsClarence",
  components: {
    ClarenceReports
  },
    created() {
    this.$auth.renewTokens().catch((err) => {
      (err.message);
    });
   },
  data() {
    return {
      profileportal : null,
      Auth0loggedIn: false,
      profile: {},
      themepref: this.$ThemePref,
      accessGroup: null,
    };
  },
  async mounted() {

  },

   methods: {
      handleLoginEvent(data) {
      this.profile = data.profile;
      this.Auth0loggedIn = data.Auth0loggedIn;
      this.profileportal = data.profileportal;
      this.themepref = data.themepref;
      this.accessGroup = data.accessGroup;
    },
  }
};
</script>

<style></style>